<template>
  <div>
    <el-card>
        <el-form ref="form" :model="form" label-width="80px" :inline="true">
          <el-form-item label="应用名称:" prop="keyword">
            <!-- v-model="form.keyword"  -->
            <!-- <el-input v-model="filterText" :fetch-suggestions="searchList" @select="handleSelect"></el-input> -->
            <el-select
                v-model="form.keyword"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="searchList"
                :loading="loading">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="应用状态:" prop="appStatus">
            <el-select v-model="form.appStatus" placeholder="请选择活动区域" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="注销" value="0"></el-option>
              <el-option label="正常" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
              <el-button type="primary"  @click="searchEvent">查询</el-button>
              <el-button type="primary"  @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card>
        <el-table v-loading="listLoading" :data="list">

            <el-table-column label="应用名称" prop='name'></el-table-column>

            <el-table-column label="应用类型" prop='apptype'>
                <template slot-scope="scope">
                    {{tableVal(scope.row.apptype, appType) }}
                </template>
            </el-table-column>

            <el-table-column label="负责人" prop='cname'></el-table-column>

            <el-table-column label="审核状态" prop='approval'>
                <template slot-scope="scope">
                    {{tableVal(scope.row.approval,approvalList) }}
                </template>
            </el-table-column>
            <el-table-column label="应用状态" prop='appstatus'>
                <template slot-scope="scope">
                    {{scope.row.appstatus == 1?"正常":"注销" }}
                </template>
            </el-table-column>
            <!-- <el-table-column label="备注" prop='comment'></el-table-column> -->

            <el-table-column label="操作" width="120">// v-w-role="'cicdYyglYylbShan'"
                <!-- <template slot-scope="{ row, $index }">
                    <el-button
                    v-if='row.approval === 0 | row.approval === 3'
                     type="text"
                     @click="handleDel(row.id, $index, 1)" v-w-role="'ITSM-0105'">审核</el-button>
                </template> -->
                <template slot-scope="{ row, $index }">
                    <el-button type="text" v-if="row.appstatus == 1"
                     @click="changeStatusEvent(row.id, '0')">注销</el-button>
                     <el-button type="text" v-else
                     @click="changeStatusEvent(row.id, '1')">恢复</el-button>
                </template>
            </el-table-column>

        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.pageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="form.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>

    </el-card>

  </div>
</template>

<script>
    import services from './appcenter.services'
    export default {
        data() {
            return {
                form:{
                    keyword:'',
                    appStatus:'',
                    pageIndex: 1,
                    pageSize: 10
                },
                list: null,
                total: 0,
                listLoading: true,
                filterText: '', // input value
                loading:false,
                options:[]
                // listQuery: {
                //     page_num: 1,
                //     page_size: 10
                // },

            }
        },

        mounted() {
            // console.log(this.dictionary);
            // console.log(this.approval);
            this.fetchData()
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            appType() {
                return this.dictionary.app_type
            },
            approvalList() {
                return this.dictionary.approval
            }

        },

        methods: {
            // 点击搜索应用及目录
            searchList(query) {
                if (query !== '') {
                    this.loading = true;
                    services.appSearch(query)
                    .then(res => {
                        this.loading = false;
                        console.log(res)
                        this.options = res.app_list
                    })
                    .catch(err => this.$message.error(err.message))
                    // services.getAppList(query)
                    // .then(res => {
                    //     console.log(res)
                    // })
                    // .catch(err => this.$message.error(err.message))

                } else {
                  this.options = [];
                }
                // console.log(this.filterText)
                // if (this.filterText) {

                // } else {
                //     // this.menuUsefalg = false
                // }
            },
            handleSelect(item){
                console.log(item)
            },
            // 请求数据
            fetchData() {
                this.listLoading = true
                this.form.pageIndex  = 1
                services.appList(this.form)
                    .then(response => {
                        this.list = response.app_list
                        this.total = response.total
                        this.listLoading = false
                    })
                    .catch(err => this.$message.error(err.message))
            },
            searchEvent(){
                this.form.pageIndex = 1
                this.fetchData()
            },
            resetForm(){
                this.form = {
                    keyword:'',
                    appStatus:'',
                    pageIndex: 1,
                    pageSize: 10
                }
            },

            // 页数改变时
            handleSizeChange(val) {
                let pages = Math.ceil(this.total / val)
                this.form.pageSize = val
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1
                }
                this.fetchData()
            },

            // 页码改变时
            handleCurrentChange(val) {
                    this.form.pageIndex = val
                    this.fetchData()
            },

            // 审批
            handleDel(id, ind) {
                this.$router.push({
                    path: '/auditApp',
                    query: {
                        callback: this.fetchData,
                        ind: ind,
                        app_id: id,
                    }
                })
            },
            //操作
            changeStatusEvent(id,code){
                console.log(id,code)
                let msg=''
                if(code == '0'){
                    //注销
                    msg='注销'
                }else{
                    //恢复
                    msg='恢复'
                }
                this.$confirm('此操作将'+msg+', 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    services.operateEvent({app_id:id,operate_code:code})
                    .then(() => {
                        this.$message({
                            type: 'success',
                            message: msg+'成功!'
                        });
                        this.fetchData()
                    })
                    .catch(err => this.$message.error(err.message))

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'+msg
                  });
                });
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) str =  "无"
                str = res[0].cname
                return str
            },
        }
    }
</script>
